import axios from 'axios';

/**
 * Fetches the list of all campaigns for the user's organization.
 * @returns {Promise<Object>} A promise that resolves to the API response.
 */
export const getCampaigns = () => {
	return axios({
		method: 'GET',
		url: '/api/campaigns',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			'Access-Control-Allow-Credentials': true
		},
		withCredentials: true
	});
};

/**
 * Fetches all details for a single selected campaign.
 * @param {number} campaignId - The ID of the campaign to fetch details for.
 * @returns {Promise<Object>} A promise that resolves to the API response.
 */
export const getCampaignDetails = (campaignId) => {
	return axios({
		method: 'GET',
		url: `/api/campaigns/${campaignId}`,
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			'Access-Control-Allow-Credentials': true
		},
		withCredentials: true
	});
};
